import { Injectable } from '@angular/core';
import { MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { Span, SpanOptions } from '@opentelemetry/api';
import { subMilliseconds } from 'date-fns';
import { NoopSpan } from './noop-span';
import { ObservabilityService } from './observability-service';

@Injectable({
  providedIn: 'root',
})
export class ViewReportObservabilityService {
  private span: Span = new NoopSpan();

  constructor(
    private observabilityService: ObservabilityService,
    private metaTagsService: MetaTagsService
  ) {}

  public startTrace(reportToken: string) {
    const options: SpanOptions = {
      startTime: subMilliseconds(new Date(), window.performance.now()),
      attributes: {
        'mode.webapp_ui.report_run_token': this.metaTagsService.getTag(MetaTags.ReportRunToken) || '',
        'mode.webapp_ui.report_token': reportToken,
        'mode.webapp_ui.user_name': this.metaTagsService.getTag(MetaTags.CurrentUsername) || '',
        'mode.webapp_ui.org_name': this.metaTagsService.getTag(MetaTags.OwnerUsername) || '',
      },
    };
    this.span = this.observabilityService.startTrace('view-report', options);
  }

  public endTrace() {
    this.span.end();
  }
}
